// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ew-3";
export var flatBottomCorners = "_ew-5";
export var productImage = "_ew-0";
export var quantityContainer = "_ew-2";
export var quantityHeader = "_ew-6";
export var tooltip = "_ew-1";
export var wrapAndEllipsesOverflow = "_ew-4";